import React from 'react';
import ReactDOM from 'react-dom';
import '@src/common/resetMobile.css';
import Layout from './layout';

/* eslint-disable */
ReactDOM.render(<Layout content={allData} />, document.getElementById('root'));
/* eslint-enable */
